var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid p-0",attrs:{"id":"app"}},[_c('Nav'),_c('Hero'),_c('About'),_c('Services'),_c('Friends'),_c('Reviews'),_c('Contact')],1)}
var staticRenderFns = []

export { render, staticRenderFns }